import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../styles/userPanel.scss";
import {
  TransformWrapper,
  TransformComponent,
  ReactZoomPanPinchRef,
} from "react-zoom-pan-pinch";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import CenterFocusStrongIcon from "@mui/icons-material/CenterFocusStrong";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { axiosInstance } from "../../utils/tokenSetCookie";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { AxiosError } from "axios";
import {
  favoriteAnim,
  ControlsProps,
  posterData,
  FavAnimationData,
} from "../../types/types";
import { useLanguageContext } from "../../components/language/languageContext";

import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import {
  MediaPlayer,
  MediaPlayerInstance,
  MediaProvider,
  Poster,
} from "@vidstack/react";

import {
  defaultLayoutIcons,
  DefaultVideoLayout,
} from "@vidstack/react/player/layouts/default";

import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ShareIcon from "@mui/icons-material/Share";
import FavoriteIcon from "@mui/icons-material/Favorite";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PdfViewerModal from "../pdf_view/pdfviewermodal";
import { useCart } from "../../hooks/shareContext";
import { debounce } from "lodash"; // Import lodash debounce
import LoginRestriction from "../../utils/loginRestriction";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
const BASE_SHORT_URL = import.meta.env.VITE_BASE_SHORT_URL;
const VIDEO_BASE_URL = import.meta.env.VITE_VIDEO_BASE_URL;

type AnimationContent = {
  animationId: number;
  introductionTagName: string;
  conditionTagName: string;
  symptomsTagName: string;
  actionTagName: string;
};

const Controls: React.FC<ControlsProps> = ({
  zoomIn,
  zoomOut,
  resetTransform,
}) => (
  <Box
    sx={{
      textAlign: "end",
      position: "absolute",
      top: "10px",
      left: "0",
      right: "0",
      zIndex: "9",
    }}
  >
    <ZoomInIcon
      fontSize="medium"
      onClick={() => zoomIn()}
      sx={{ cursor: "pointer", color: "#fff", marginRight: "0.5%" }}
    />
    <ZoomOutIcon
      fontSize="medium"
      onClick={() => zoomOut()}
      sx={{ cursor: "pointer", color: "#fff", marginRight: "0.5%" }}
    />
    <CenterFocusStrongIcon
      fontSize="medium"
      onClick={() => resetTransform()}
      sx={{ cursor: "pointer", color: "#fff", marginRight: "0.5%" }}
    />
  </Box>
);

const Favorites: React.FC = () => {
  const { defaultLanguage } = useLanguageContext();
  const { t } = useTranslation();
  const {
    selectAnim,
    setSelectAnim,
    activeAnim,
    setActiveAnim,
    activeAnimIndex,
    setActiveAnimIndex,
    cartCount,
    incrementCartCount,
    decrementCartCount,
  } = useCart();
  const transformComponentRef = useRef<ReactZoomPanPinchRef | null>(null);
  const [_selectedImage, setSelectedImage] = useState<string | null>(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFullscreen, isSetFullscreen] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isManuallyPlayed, _setIsManuallyPlayed] = useState(false); // Tracks manual play state
  //  After  Get System id
  const [isThumbnail, setThumbnail] = useState<posterData[]>([]);
  const [_loading, setLoading] = useState(true);
  const [isFavoriteAnim, setFavoriteAnim] = useState(false);
  const [isFavList, setFavList] = useState<favoriteAnim[]>([]);
  const [favourites, setFavourites] = useState<favoriteAnim[]>([]);
  const [isActiveAnimation, setActiveAnimation] = useState(Number);
  const [currentAnimationData, setCurrentAnimationData] =
    useState<FavAnimationData | null>();
  const sliderRef = useRef<any>(null);
  const [isAnimContent, setIsAnimContent] = useState<AnimationContent | null>(
    null
  );
  const [isRestrictionOpen, setIsRestrictionOpen] = useState(false);
  const boxRef = useRef<HTMLDivElement | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPDF, setIsPDF] = useState(false);
  const [isShortUrl, setShortUrl] = useState(String);
  const [changeCount, setChangeCount] = useState(cartCount);
  const [videoSize, setVideoSize] = useState({ width: 0, height: 0 });

  const userViewType = Number(localStorage.getItem("viewType"));


  const hasPlayedOnce = useRef(false);
  const currentVideoId = useRef<string | null>(null);



  useEffect(() => {
    // Function to fetch data
    const InitialFavoritesListData = async () => {
      try {
        const response = await axiosInstance.get(
          API_BASE_URL + "animation-favorites/list-favorites"
        );

        if (response.status >= 200 && response.status <= 300) {
          setFavourites(response.data.data.data);
          setCurrentAnimationData(response.data.data.data[0]);
          setActiveAnimation(response.data.data.data[0].animationId);
          setActiveAnim(response.data.data.data[0].animationId);
          setIsPDF(response.data.data.data[0].animationPdfStatus);

          const animIsAvail = response.data.data.data.some(
            (item: any) => item.animationId === isActiveAnimation
          );
          setFavoriteAnim(animIsAvail);
          setActiveAnimIndex(0);
          // setIsPDF(response.data.data.data[0].animationPdfStatus);
        }
      } catch (error) {
        const errCode = error as AxiosError<{ status: number }>;
        if (errCode.response && errCode.response.status === 401) {
          setIsRestrictionOpen(true);
        }
        throw error;
      }
    };
    InitialFavoritesListData();
  }, []);


  //   Animation posters list
  useEffect(() => {
    if (isActiveAnimation) {
      const payload = {
        animationId: JSON.stringify(isActiveAnimation),
      };
      const fetchData = async () => {
        try {
          const response = await axiosInstance.post(
            API_BASE_URL + "animation/animation-posters",
            payload
          );
          if (response.status >= 200 && response.status <= 300) {
            setThumbnail(response.data.data);
          } else {
            console.log("Error");
          }
        } catch (error) {
          const errCode = error as AxiosError<{ status: number }>;
          if (errCode.response && errCode.response.status === 401) {
            setIsRestrictionOpen(true);
          } else {
            toast.error("Something went wrong", {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
            });
          }
          throw error;
        }
      };
      fetchData(); // Passing the payload as an argument
    }

  }, [isActiveAnimation]); // Empty dependency array ensures it runs only once on page load

  // Animation Description Content
  useEffect(() => {
    if (isActiveAnimation) {
      const payload = {
        animationId: JSON.stringify(isActiveAnimation),
      };
      const fetchData = async () => {
        try {
          const response = await axiosInstance.post(
            API_BASE_URL + "animation/animation-description",
            payload
          );
          if (response.status >= 200 && response.status <= 300) {
            const animationArray = response.data.data;
            if (Array.isArray(animationArray) && animationArray.length > 0) {
              const animationContent = animationArray[0]; // Extract the first object
              setIsAnimContent(animationContent);
            } else {
            }
          } else {
            console.log("Error");
          }
        } catch (error) {
          const errCode = error as AxiosError<{ status: number }>;
          if (errCode.response && errCode.response.status === 401) {
            setIsRestrictionOpen(true);
          } else {
            toast.error("Something went wrong", {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
            });
          }
          throw error;
        }
      };
      fetchData(); // Passing the payload as an argument
    }
  }, [isActiveAnimation]); // Empty dependency array ensures it runs only once on page load

  const videoPlayerRef = useRef<MediaPlayerInstance | null>(null);

  useEffect(() => {
    const videoPlayer = videoPlayerRef.current;

    if (videoPlayer) {
      if (isPlaying) {
        videoPlayer.play().catch((err: any) => {
          console.error(`Error playing video: ${err.message}`);
        });
      } else {
        videoPlayer.pause();
      }
    }
  }, [isPlaying]);

  // Handle fullscreen change event
  useEffect(() => {
    const handleFullscreenChange = () => {
      if (!document.fullscreenElement) {
        isSetFullscreen(false);
        setSelectedImage(null);
        if (isManuallyPlayed) {
          setIsPlaying(false);
        } else {
          setIsPlaying(false);
        }
      }
    };
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, [isManuallyPlayed]);

  useEffect(() => {

    if (isActiveAnimation) {
      // Function to fetch data
      const FavoritesListData = async () => {
        try {
          const response = await axiosInstance.get(
            API_BASE_URL + "animation-favorites/list-favorites"
          );

          if (response.status >= 200 && response.status <= 300) {

            const animIsAvail = response.data.data.data.some(
              (item: any) => item.animationId === activeAnim
            );
            setFavList(response.data.data.data);
            setFavoriteAnim(animIsAvail);
          }
        } catch (error) {
          const errCode = error as AxiosError<{ status: number }>;
          if (errCode.response && errCode.response.status === 401) {
            setIsRestrictionOpen(true);
          }
          throw error;
        }
      };
      FavoritesListData();
    }
  }, [isActiveAnimation]);

  // Simulate a 3-second loading period
  useEffect(() => {
    if (isFavList.length > 0) {
      setLoading(true); // Start loading when modal opens
      const timer = setTimeout(() => {
        setLoading(false); // Stop loading after 2 seconds
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [isFavList]);


  // Custom Next Arrow
  const NextArrow = ({ onClick }: { onClick?: () => void }) => (
    <Box
      onClick={onClick}
      sx={{
        position: "absolute",
        top: "50%",
        right: "-40px",
        transform: "translateY(-50%)",
        width: "25px",
        height: { xs: "50px", sm: "80px", md: "110px", lg: "115", xl: "120px" }, // Responsive height for mobile, tablet, and desktop
        backgroundColor: "#1976d2",
        borderRadius: "10px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        zIndex: 10,
        "&:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.8)",
        },
      }}
    >
      <ArrowForwardIosIcon
        sx={{ color: "#fff", fontSize: "18px", marginLeft: "0px" }}
      />
    </Box>
  );

  // Custom Previous Arrow
  const PrevArrow = ({ onClick }: { onClick?: () => void }) => (
    <Box
      onClick={onClick}
      sx={{
        position: "absolute",
        top: "50%",
        left: "-40px",
        transform: "translateY(-50%)",
        width: "25px",
        height: { xs: "50px", sm: "80px", md: "110px", lg: "115", xl: "120px" }, // Responsive height for mobile, tablet, and desktop
        backgroundColor: "#1976d2",
        borderRadius: "10px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        zIndex: 10,
        "&:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.8)",
        },
      }}
    >
      <ArrowBackIosIcon
        sx={{ color: "#fff", fontSize: "18px", marginLeft: "7px" }}
      />
    </Box>
  );

  const sliderSettings = {
    infinite: false,
    speed: 2000,
    slidesToShow: 6, // Default for larger screens
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    ref: (slider: any) => (sliderRef.current = slider),

    responsive: [
      {
        breakpoint: 1536, // Large screens (lg)
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1, // Move 4 slides per click
        },
      },
      {
        breakpoint: 1200, // Medium screens (md)
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1, // Move 4 slides per click
        },
      },
      {
        breakpoint: 900, // Small screens (sm)
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1, // Move 2 slides per click
        },
      },
      {
        breakpoint: 600, // Extra small screens (xs)
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1, // Move 1 slide per click
        },
      },
    ],
  };

  const handlePrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? (isThumbnail?.length || 0) - 1 : prevIndex - 1
    );
    setTimeout(() => {
      transformComponentRef.current?.resetTransform(); // Resets zoom and position
    }, 50);
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === (isThumbnail?.length || 0) - 1 ? 0 : prevIndex + 1
    );
    setTimeout(() => {
      transformComponentRef.current?.resetTransform(); // Resets zoom and position
    }, 50);
  };

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "ArrowLeft") {
        handlePrevious();
      } else if (e.key === "ArrowRight") {
        handleNext()
      }
    }

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handlePrevious, handleNext])

  const handleViewImage = (src: string, index: number) => {
    setCurrentIndex(index);
    setSelectedImage(src);
    isSetFullscreen(!isFullscreen);
    setIsPlaying(false);
    const element = document.getElementById("imageFullscreen");
    if (!isFullscreen) {
      if (element?.requestFullscreen) {
        element.requestFullscreen().catch((err) => {
          console.error(
            `Error attempting to enable full-screen mode: ${err.message} (${err.name})`
          );
        });
      }
    }
  };
  const handleCopyAnimUrl = () => {
    const payload = {
      trackType: "share_copy_generate_link",
      languageId: defaultLanguage,
      websiteId: 1,
      animationId: JSON.stringify(isActiveAnimation),
    };
    const generateShortURL = async (payload: any) => {
      try {
        const response = await axiosInstance.post(
          API_BASE_URL + "share/copy-shortUrl",
          payload
        );
        if (response.status >= 200 && response.status <= 300) {
          const shortCode = response.data.data.links[0].shortUrl;
          // Split the URL by '/'
          const urlSegments = shortCode.split("/");
          // Get the last segment
          const getCode = urlSegments[urlSegments.length - 1];

          const shortUrl = `${BASE_SHORT_URL}/${getCode}`;
          setShortUrl(shortUrl);
          navigator.clipboard.writeText(shortUrl).then(() => { });
          navigator.clipboard.writeText(shortUrl).then(() => { });
          // Copy the short URL to the clipboard
          toast.success("Animation Copied successfully !!!", {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      } catch (error) {
        const errCode = error as AxiosError<{ status: number }>;
        if (errCode.response && errCode.response.status === 401) {
          setIsRestrictionOpen(true);
        } else {
          toast.error("Something went wrong", {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
          });
        }
        throw error;
      }
    };
    generateShortURL(payload);

    navigator.clipboard.writeText(isShortUrl).then(() => { });
  };

  const setChooseVideo = (id: number, index: number) => {

    setActiveAnimation(id);
    const getChooseAnimation = favourites.find(
      (item) => item.animationId === id
    );
    setCurrentAnimationData(getChooseAnimation);

    setActiveAnimIndex(index);
  };

  const handleOpenModal = () => setIsModalOpen(true);

  const handleCloseModal = () => setIsModalOpen(false);

  const handleFavoriteToggle = async (animId: number) => {
    const updatedFavourites = favourites.filter(
      (item) => item.animationId !== animId
    );
    setFavourites(updatedFavourites);

    const isFavorite = isFavList.some((item) => item.animationId === animId);
    const url = isFavorite
      ? API_BASE_URL + "animation-favorites/remove-favorite"
      : API_BASE_URL + "animation-favorites/add-favorite";

    const payload = isFavorite
      ? { animationId: animId }
      : { webSiteId: 1, animationId: animId };

    try {
      const response = isFavorite
        ? await axiosInstance.delete(url, { data: payload })
        : await axiosInstance.post(url, payload);

      if (response.status >= 200 && response.status < 300) {
        FavListData();
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      const errCode = error as AxiosError<{ status: number }>;
      if (errCode.response && errCode.response.status === 401) {
        setIsRestrictionOpen(true);
      } else {
      }
      throw error;
    }
  };

  const FavListData = async () => {
    try {
      const response = await axiosInstance.get(
        API_BASE_URL + "animation-favorites/list-favorites"
      );

      if (response.status >= 200 && response.status < 300) {
        const favorites = response.data.data.data;

        setFavList(favorites);

        // Check if the active animation exists in the favorite list
        setFavoriteAnim(
          favorites.some((item: any) => item.animationId === activeAnim)
        );

        setFavourites(response.data.data.data);
        setCurrentAnimationData(response.data.data.data[0]);
        setActiveAnimation(response.data.data.data[0].animationId);
        setActiveAnim(response.data.data.data[0].animationId);
      }
    } catch (error) {
      console.error("Error fetching favorites:", error);
    }
  };

  const handleClickLink = (id: number) => {
    setSelectAnim((prevIds: number[]) => [...prevIds, id]);
    setChangeCount(cartCount + 1);
    incrementCartCount(changeCount);
  };

  const handleRemoveAnim = (rid: number) => {
    const updatedSelectAnim = selectAnim.filter((item) => item !== rid);
    setSelectAnim(updatedSelectAnim);
    setChangeCount(cartCount - 1);
    decrementCartCount(changeCount);
  };

  const fetchVideoData = async (videoId: string) => {
    try {
      const requestData = {
        animationId: parseInt(videoId),
        trackType: "website",
      };

      const response = await axiosInstance.post(
        API_BASE_URL + "animation-viewed/add",
        requestData
      );
      if (response.status >= 200 && response.status <= 300) {
        // let response_data = response.data.data;
      } else {
        console.log("Error");
      }
    } catch (err) {
      console.log("Error", err);
    }
  };

  const handleVideoPlay = () => {
    if (!currentAnimationData?.animationId) return; // Ensure video ID exists

    const videoIdString = String(currentAnimationData.animationId); // Convert to string

    if (!hasPlayedOnce.current || currentVideoId.current !== videoIdString) {
      hasPlayedOnce.current = true;
      currentVideoId.current = videoIdString; // Store as string
      fetchVideoData(videoIdString); // Execute API call
    }
  };

  const updateVideoSize = () => {
    const videoElement = document.getElementById(
      `videoslider${currentAnimationData?.animationId}`
    );

    if (videoElement) {
      setVideoSize({
        width: videoElement.clientWidth,
        height: videoElement.clientHeight,
      });
    }
  };

  useEffect(() => {
    const videoElement = document.getElementById(
      `videoslider${currentAnimationData?.animationId}`
    );

    if (!videoElement) return;

    const updateSize = (entries: ResizeObserverEntry[]) => {
      for (let entry of entries) {
        const { width, height } = entry.contentRect;

        setVideoSize((prevSize) => {
          if (prevSize.width !== width || prevSize.height !== height) {
            return { width, height }; //  Update only if different
          }
          return prevSize; // No update if same
        });
      }
    };

    // Debounce the function to avoid too many updates
    const debouncedUpdateSize = debounce(updateSize, 100);

    const observer = new ResizeObserver(debouncedUpdateSize);
    observer.observe(videoElement);

    window.addEventListener("resize", updateVideoSize);


    return () => {
      observer.disconnect();
      window.removeEventListener("resize", updateVideoSize);
      debouncedUpdateSize.cancel(); // Clean up debounce
    };
  }, [currentAnimationData?.animationId]);

  useEffect(() => {
    if (!isFullscreen && transformComponentRef.current) {
      setTimeout(() => {
        transformComponentRef.current?.resetTransform(); // Resets zoom and position
      }, 50); // Small delay to ensure the component is updated
    }
  }, [isFullscreen]);
  return (
    <Box
      sx={{
        paddingTop: "10px",
        paddingBottom: "10px",
        paddingRight: { xs: "15px", sx: "15px", lg: "1px" },
      }}
    >


      <>
        <Box sx={{ margin: "0 auto", paddingX: "15px" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              paddingRight: { xs: "0px", sm: "10px", md: "30px", lg: "1px" }, // Add space on the right for mobile and larger screens
            }}
          >
            <Grid container>
              <Grid
                item
                sm={12}
                md={6} // Reduce size for medium screens by adjusting this value
                sx={{
                  display: "flex",
                  padding: {
                    xs: "0 4px",
                    sm: "0 2px",
                    md: "0 10px",
                  }, // Adjust padding for mobile and small screens
                  alignItems: "center",
                  justifyContent: { xs: "center", sm: "flex-start" }, // Center items on mobile, left align on larger screens
                  flexDirection: { xs: "column", sm: "row" }, // Stack content vertically on mobile, horizontal on larger screens
                  width: "100%", // Ensure it takes full width of its container
                }}
              >
                <Typography
                  variant="h5"
                  mt={2}
                  sx={{
                    mb: 2,
                    color: "#004F98",
                    fontWeight: "bold",
                    fontSize: "24px",
                  }}
                >
                  Favorite Animations
                </Typography>
              </Grid>

              {favourites.length > 0 && (
                <Grid
                  item
                  sm={12}
                  md={6}
                  sx={{
                    display: "flex",
                    padding: { xs: "0 10px", sm: "0 10px" }, // Adjust padding for mobile and small screens
                    justifyContent: { xs: "center", sm: "flex-end" }, // Center items on mobile, left align on larger screens
                    flexDirection: { xs: "column", sm: "row" }, // Stack content vertically on mobile, horizontal on larger screens
                    width: "100%", // Ensure it takes full width of its container
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    {isThumbnail &&
                      isThumbnail.map((thumb, index) => (
                        <Box
                          key={index}
                          sx={{ position: "relative", width: 90 }}
                        >
                          <Box
                            sx={{
                              width: "100%",
                              height: { xs: 20, sm: 30, md: 40, lg: 50 }, // Reduced height for landscape
                              borderRadius: 2,
                              overflow: "hidden",
                              display: "flex",
                              justifyContent: "center",
                              cursor: "pointer",
                              transition: "transform 0.2s ease-in-out",
                              boxShadow: "3px 3px 9px 0px rgb(79 77 77 / 65%)",
                              "&:hover": {
                                transform: "scale(1.05)",
                                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)",
                              },
                            }}
                          >
                            <img
                              src={thumb.imageUrl}
                              id="image-full"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                          </Box>
                          <Box
                            sx={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              opacity: 0,
                              transition: "opacity 0.3s ease-in-out",
                              backgroundColor: "rgba(0, 0, 0, 0.5)",
                              borderRadius: 2,
                              "&:hover": {
                                opacity: 1,
                              },
                            }}
                          >
                            <Tooltip title="View Image">
                              <IconButton
                                onClick={() =>
                                  handleViewImage(thumb.imageUrl, index)
                                }
                                sx={{
                                  color: "#fff",
                                  width: "25px",
                                  height: "25px",
                                  backgroundColor: "rgba(255, 255, 255, 0.3)",
                                  "&:hover": {
                                    backgroundColor: "rgba(255, 255, 255, 0.5)",
                                  },
                                }}
                              >
                                <VisibilityIcon sx={{ fontSize: "15px" }} />
                              </IconButton>
                            </Tooltip>
                          </Box>

                          {/* </>
         )} */}
                        </Box>
                      ))}
                    {/* PDF view */}
                    {isPDF ? (
                      <Tooltip title="PDF">
                        <IconButton
                          onClick={handleOpenModal}
                          sx={{
                            bgcolor: "#1976d2",
                            "&:hover": { bgcolor: "#be1e2d" },
                            "&:hover .dashicon": { color: "#fff" },
                            width: { xs: 40, sm: 50 }, // Smaller width on mobile (xs), larger on sm+
                            height: { xs: 40, sm: 50 }, // Smaller height on mobile (xs), larger on sm+
                            "& .dashicon": {
                              fontSize: { xs: "20px", sm: "24px" }, // Smaller icon size on mobile
                            },
                          }}
                        >
                          <PictureAsPdfIcon
                            className="dashicon"
                            sx={{ color: "#fff" }}
                          />
                        </IconButton>
                      </Tooltip>
                    ) : null}

                    {isModalOpen && (
                      <Box sx={{ marginTop: 2 }}>
                        <PdfViewerModal
                          animationId={isActiveAnimation}
                          onClose={handleCloseModal}
                        />
                      </Box>
                    )}

                    <Tooltip title="Copy">
                      <IconButton
                        sx={{
                          bgcolor: "#1976d2",
                          "&:hover": { bgcolor: "#be1e2d" },
                          "&:hover .dashicon": { color: "#fff" },
                          width: { xs: 40, sm: 50 }, // Smaller width on mobile (xs), larger on sm+
                          height: { xs: 40, sm: 50 }, // Smaller height on mobile (xs), larger on sm+
                          "& .dashicon": {
                            fontSize: { xs: "20px", sm: "24px" }, // Smaller icon size on mobile
                          },
                        }}
                        onClick={handleCopyAnimUrl}
                      >
                        <ContentCopyIcon
                          className="dashicon"
                          sx={{ color: "#fff" }}
                        />
                      </IconButton>
                    </Tooltip>
                    {userViewType === 1 && (
                      <>
                        <Tooltip title="Share">
                          <IconButton
                            sx={{
                              bgcolor: "#1976d2",
                              "&:hover": { bgcolor: "#be1e2d" },
                              "&:hover .dashicon": { color: "#fff" },
                              width: 50,
                              height: 50,
                            }}
                            onClick={() =>
                              selectAnim.includes(activeAnim)
                                ? handleRemoveAnim(activeAnim)
                                : handleClickLink(activeAnim)
                            }
                          >
                            {selectAnim.includes(activeAnim) ? (
                              <CloseIcon
                                className="dashicon"
                                sx={{ color: "#fff" }}
                              />
                            ) : (
                              <ShareIcon
                                className="dashicon"
                                sx={{ color: "#fff" }}
                              />
                            )}
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Favorites">
                          <IconButton
                            sx={{
                              backgroundColor: isFavoriteAnim
                                ? "#ffd2d2"
                                : "#1976d2",
                              "&:hover": { bgcolor: "#be1e2d" },
                              "&:hover .dashicon": { color: "#fff" },
                              width: 50,
                              height: 50,
                            }}
                            onClick={() => handleFavoriteToggle(activeAnim)}
                          >
                            <FavoriteIcon
                              className="dashicon"
                              sx={{
                                color: isFavoriteAnim ? "#f20808" : "#fff",
                              }}
                            />
                          </IconButton>
                        </Tooltip>
                      </>
                    )}
                  </Box>
                </Grid>
              )}
            </Grid>
          </Box>
          {favourites.length > 0 && (
            <Box
              sx={{
                padding: { xs: "10px", sm: "20px", md: "10px", lg: "10px" },
                borderRadius: "8px",
                paddingRight: { xs: "5px", sm: "1px" },
              }}
            >
              <Box>
                <div className="AfterLogin">
                  <Grid container columnSpacing={2}>
                    {/* <Grid item sm={12} md={7}> */}
                    <Grid
                      item
                      sm={12}
                      md={7}
                      lg={7}
                      xl={6.5}
                      sx={{ display: "flex", alignItems: "center" }}
                    >
                      <Grid md={12}>
                        <Box sx={{ borderRadius: "10px" }}>
                          <MediaPlayer
                            ref={videoPlayerRef}
                            key={currentAnimationData?.tagName}
                            id={`videoslider${currentAnimationData?.animationId}`}
                            data-vds-id={VIDEO_BASE_URL}
                            className="carouselvideo"
                            src={
                              VIDEO_BASE_URL + currentAnimationData?.videoUrl
                            }
                            viewType="video"
                            streamType="on-demand"
                            logLevel="warn"
                            crossOrigin
                            autoPlay={isPlaying}
                            playsInline
                            controls={false}
                            title={
                              currentAnimationData?.tagName
                                ? t(currentAnimationData?.tagName)
                                : ""
                            }
                            poster={currentAnimationData?.bannerUrl}
                            onPlay={handleVideoPlay} //  Executes API once per video
                            style={{ height: "100%", borderRadius: "10px" }}
                          >
                            <MediaProvider>
                              <Poster className="vds-poster" />
                            </MediaProvider>
                            <DefaultVideoLayout icons={defaultLayoutIcons} />
                          </MediaPlayer>
                        </Box>
                      </Grid>
                    </Grid>
                    {/* <Grid item sm={12} md={5}> */}
                    <Grid item sm={12} md={5} lg={5} xl={5.5}>
                      <Grid md={12}>
                        <Box
                          ref={boxRef}
                          className="animation-content"
                          sx={{
                            boxShadow: 3,
                            borderRadius: "10px",
                            position: "relative",
                            width: "100%",
                            maxWidth: "100%",

                            height: {
                              xs: "40vh",
                              sm: "45vh",
                              md: "48vh",
                              lg: "51.8vh", // Default large size
                              xl: "56.7vh", // Default extra-large size
                            },
                            overflowY: "auto", // Enables scrolling only when content overflows
                            paddingRight: { xs: 0.5, lg: 3, xl: 3 },
                            padding: "10px 0px 10px 10px",
                          }}
                          style={{
                            height: videoSize.height
                              ? `${videoSize.height}px`
                              : undefined, // Override if available
                            transition: "height 0.4s ease-in-out",
                          }}
                        >
                          <Typography
                            variant="h5"
                            sx={{
                              fontWeight: { xs: 550, sm: 700 },
                              fontSize: { xs: "15px", sm: "22px" },
                              textAlign: "left",
                              marginBottom: "5px",
                              whiteSpace: "normal",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "-webkit-box",
                              WebkitLineClamp: 1,
                              WebkitBoxOrient: "vertical",
                              width: "100%",
                              color: "#004F98",
                            }}
                          >
                            {currentAnimationData?.tagName
                              ? t(currentAnimationData.tagName)
                              : ""}
                          </Typography>
                          {

                            isAnimContent && isAnimContent ? (
                              <>

                                <Typography
                                  variant="h6"
                                  sx={{
                                    fontSize: { xs: "16px", sm: "16px" },
                                    mb: 1,
                                  }}
                                  component="div"
                                >
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        isAnimContent?.introductionTagName ||
                                        "",
                                    }}
                                  />
                                </Typography>
                                {isAnimContent &&
                                  isAnimContent?.conditionTagName ? (
                                  <Box>
                                    <Typography
                                      variant="h6"
                                      mt={2}
                                      sx={{
                                        mb: 1,
                                        color: "#004F98",
                                        fontWeight: "bold",
                                        fontSize: { xs: "15px", sm: "17px" },
                                      }}
                                    >
                                      Condition
                                    </Typography>
                                    <Typography
                                      variant="h6"
                                      sx={{
                                        fontSize: { xs: "16px", sm: "16px" },
                                        mb: 1,
                                      }}
                                      component="div"
                                    >
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            isAnimContent?.conditionTagName ||
                                            "",
                                        }}
                                      />
                                    </Typography>
                                  </Box>
                                ) : (
                                  ""
                                )}
                                {isAnimContent &&
                                  isAnimContent?.symptomsTagName ? (
                                  <Box>
                                    <Typography
                                      variant="h6"
                                      mt={2}
                                      sx={{
                                        mb: 0,
                                        color: "#004F98",
                                        fontWeight: "bold",
                                        fontSize: { xs: "15px", sm: "17px" },
                                      }}
                                    >
                                      Symptoms
                                    </Typography>
                                    <Typography
                                      variant="h6"
                                      sx={{
                                        fontSize: { xs: "16px", sm: "16px" },
                                        mb: 1,
                                      }}
                                    // >
                                    >
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            isAnimContent?.symptomsTagName ||
                                            "",
                                        }}
                                      />
                                    </Typography>
                                  </Box>
                                ) : (
                                  ""
                                )}
                                {isAnimContent &&
                                  isAnimContent?.actionTagName ? (
                                  <Box>
                                    <Typography
                                      variant="h6"
                                      mt={2}
                                      sx={{
                                        mb: 0,
                                        color: "#004F98",
                                        fontWeight: "bold",
                                        fontSize: { xs: "15px", sm: "17px" },
                                      }}
                                    >
                                      Actions
                                    </Typography>
                                    <Typography
                                      variant="h6"
                                      sx={{
                                        fontSize: { xs: "16px", sm: "16px" },
                                      }}
                                    >
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            isAnimContent?.actionTagName || "",
                                        }}
                                      />
                                    </Typography>
                                  </Box>
                                ) : (
                                  ""
                                )}
                              </>
                            ) : (
                              <>
                                <Typography
                                  variant="h6"
                                  mt={1}
                                  sx={{ fontSize: "16px", mb: 1 }}
                                >
                                  Our pre-production phase is where the magic
                                  begins! This is the time for brainstorming
                                  ideas, crafting detailed storyboards, and
                                  shaping the overall concept that drives the
                                  animation. We dive deep into defining the
                                  story, creating intricate 3D models, and
                                  establishing the perfect setting and style
                                  that resonates with your audience.
                                </Typography>
                                <Typography
                                  variant="h6"
                                  mt={2}
                                  sx={{
                                    mb: 0,
                                    color: "#004F98",
                                    fontWeight: "bold",
                                    fontSize: "17px",
                                  }}
                                >
                                  Crafting the Script: Accuracy Meets Engaging
                                  Content
                                </Typography>
                                <Typography
                                  variant="h6"
                                  sx={{ fontSize: "16px", mb: 1 }}
                                >
                                  Once we've fine-tuned your concept together,
                                  it's time to bring it to life with a
                                  well-crafted script. Our experienced team
                                  collaborates closely with your team and with
                                  our own in-house medical professionals to
                                  ensure everything we communicate is accurate
                                  and easy to understand. We work together to
                                  ensure the draft script sounds professional
                                  yet remains accessible for patients. This
                                  script acts as a detailed blueprint, outlining
                                  dialogue, voiceovers, actions, and
                                  scenes—setting the stage for a captivating
                                  production.
                                </Typography>

                                <Typography
                                  variant="h6"
                                  mt={2}
                                  sx={{
                                    mb: 0,
                                    color: "#004F98",
                                    fontWeight: "bold",
                                    fontSize: "17px",
                                  }}
                                >
                                  Storyboarding and Animation Planning:
                                  Visualizing the Story
                                </Typography>
                                <Typography
                                  variant="h6"
                                  sx={{ fontSize: "16px", mb: 1 }}
                                >
                                  Storyboarding is a crucial step where we
                                  transform our script into a visual narrative.
                                  Here, we sketch each scene or compile
                                  references to give a clear sense of how the
                                  animation will flow. Whether in video format,
                                  if models are ready, or still images in
                                  documents, storyboarding provides a structured
                                  overview that guides our creative journey.
                                </Typography>
                              </>
                            )
                          }
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid
                    container
                    sx={
                      {
                      }
                    }
                  >
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      className="homepage_slider"
                    >
                      <div className="slider-container">
                        <Slider
                          {...sliderSettings}
                          className="slider-favorites"
                        >
                          {favourites &&
                            favourites.map(
                              (image, index) =>
                                image.videoUrl &&
                                image.bannerUrl && ( //for Video URL is avail only show video
                                  <Box
                                    key={index}
                                    sx={{
                                      padding: {
                                        xs: "2px", // Padding for extra small screens (mobile)
                                        sm: "8px", // Padding for small screens
                                        md: "6px", // Padding for medium screens
                                        lg: "10px", // Padding for large screens
                                        xl: "8px", // Padding for extra-large screens
                                      },
                                      maxWidth: "100%",
                                      borderRadius: 6,
                                      border:
                                        activeAnimIndex === index
                                          ? "3px solid #007bff"
                                          : "transparent",
                                    }}
                                  >
                                    <Box
                                      onClick={() =>
                                        setChooseVideo(image.animationId, index)
                                      }
                                      sx={{
                                        position: "relative",
                                        width: "100%",
                                        maxWidth: "100%",
                                        top: { xs: 0 },
                                        borderRadius: { xs: 4, sm: 6 }, // Smaller border radius on mobile
                                        overflow: "hidden",
                                        cursor: "pointer",
                                        transition:
                                          "transform 0.3s ease-in-out",
                                        margin: "0 auto",
                                        boxSizing: "border-box",
                                        "&:hover": {
                                          boxShadow:
                                            "0 4px 8px rgba(0, 0, 0, 0.2)",
                                        },
                                      }}
                                    >
                                      {/* Image */}
                                      <Box
                                        sx={{
                                          position: "relative",
                                          width: "100%",
                                          height: "auto",
                                        }}
                                      >
                                        <Box
                                          component="img"
                                          src={image.bannerUrl}
                                          alt={`Slide ${index + 1}`}
                                          sx={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                            backgroundColor: "#2b2b2bde",
                                          }}
                                        />

                                        {/* Overlay */}
                                        <Box

                                          sx={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            backgroundColor: "#2b2b2bde",
                                            opacity: 0.5,
                                            width: "100%",
                                            height: "100%", // Ensures full coverage
                                          }}
                                        />
                                      </Box>

                                      {/* Play Button and Tag */}
                                      <Box
                                        sx={{
                                          position: "absolute",
                                          bottom: { xs: 0, sm: 0, md: 0 },
                                          left: { xs: 0, sm: 0, md: 0 },
                                          display: "flex",
                                          flexDirection: "row",
                                          alignItems: "center",
                                          backgroundColor: "#00000061",
                                          width: "100%",
                                          padding: "10px 15px",
                                          gap: "8px",
                                        }}
                                      >
                                        {/* Play Button */}
                                        <Box
                                          sx={{
                                            width: { xs: 20, sm: 25, md: 30 },
                                            height: {
                                              xs: 20,
                                              sm: 25,
                                              md: 30,
                                            },
                                            backgroundColor:
                                              "rgba(255, 255, 255, 0.8)",
                                            borderRadius: "50%",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            cursor: "pointer",
                                            boxShadow:
                                              "0 2px 4px rgba(0, 0, 0, 0.3)",
                                            "&:hover": {
                                              backgroundColor:
                                                "rgba(255, 255, 255, 1)",
                                            },
                                          }}
                                          onClick={() =>
                                            setChooseVideo(
                                              image.animationId,
                                              index
                                            )
                                          }
                                        >
                                          <PlayArrowIcon
                                            sx={{
                                              fontSize: {
                                                xs: 18,
                                                sm: 22,
                                                md: 26,
                                              },
                                              color: "#444",
                                            }}
                                          />
                                        </Box>

                                        {/* Tag Text */}
                                        <Box>
                                          {/* Tag Text */}
                                          <Typography
                                            variant="caption"
                                            sx={{
                                              fontSize: {
                                                xs: "14px",
                                                sm: "14px",
                                                md: "14px",
                                              },
                                              color: "#fff",
                                              textShadow:
                                                "0 1px 2px rgba(0, 0, 0, 0.6)",
                                              textAlign: "left",
                                              whiteSpace: "normal",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              display: "-webkit-box",
                                              WebkitLineClamp: 2, // Limit to 2 lines
                                              WebkitBoxOrient: "vertical",
                                              maxWidth: "100%",
                                            }}
                                          >
                                            {t(image.tagName).length > 40
                                              ? t(image.tagName).substring(
                                                0,
                                                40
                                              ) + "..."
                                              : t(image.tagName)}
                                          </Typography>
                                        </Box>
                                      </Box>
                                    </Box>
                                  </Box>
                                )
                              //for Video URL is avail only show video
                            )}
                        </Slider>
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </Box>
            </Box>
          )}

          {favourites.length == 0 && (
            <Box className="share_sec_content">
              <Typography
                variant="h6"
                sx={{
                  fontSize: "20px",
                  textAlign: "center",
                  fontWeight: "600",
                  mt: 3,
                }}
              >
                {t("please_select_your_favorites")}
              </Typography>
            </Box>
          )}
        </Box>
      </>
      {/* )} */}
      <div
        id="imageFullscreen"
        style={{ display: isFullscreen ? "block" : "none" }}
      >
        <Box className="img_view_section" sx={{}}>
          <TransformWrapper initialScale={1} ref={transformComponentRef}>
            {(utils) => (
              <React.Fragment>
                <Controls
                  zoomIn={utils.zoomIn}
                  zoomOut={utils.zoomOut}
                  resetTransform={utils.resetTransform}
                />
                {isFullscreen && (
                  <>
                    <Box
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "10px",
                        zIndex: 10,
                        transform: "translateY(-50%)",
                      }}
                    >
                      <Button
                        onClick={handlePrevious}
                        sx={{
                          background: "rgba(0,0,0,0.5)",
                          color: "#fff",
                          padding: "10px",
                          minWidth: 0,
                          borderRadius: "50%",
                          "&:hover": {
                            background: "rgba(0,0,0,0.7)",
                          },
                        }}
                      >
                        <ChevronLeftIcon />
                      </Button>
                    </Box>
                    <Box
                      sx={{
                        position: "absolute",
                        top: "50%",
                        right: "10px",
                        zIndex: 10,
                        transform: "translateY(-50%)",
                      }}
                    >
                      <Button
                        onClick={handleNext}
                        sx={{
                          background: "rgba(0,0,0,0.5)",
                          color: "#fff",
                          padding: "10px",
                          minWidth: 0,
                          borderRadius: "50%",
                          "&:hover": {
                            background: "rgba(0,0,0,0.7)",
                          },
                        }}
                      >
                        <ChevronRightIcon />
                      </Button>
                    </Box>
                  </>
                )}

                <TransformComponent
                  wrapperStyle={{
                    width: "100vw",
                    height: "100vh",
                    overflow: "auto",
                  }}
                >
                  <img
                    src={isThumbnail?.[currentIndex]?.imageUrl || ""}
                    id="image-fullscreen"
                    style={{
                      width: "100vw",
                      height: "100vh",
                      objectFit: "contain",
                      aspectRatio: window.innerWidth > 768 ? "16/9" : "9/16",
                    }}
                  />
                </TransformComponent>
              </React.Fragment>
            )}
          </TransformWrapper>
        </Box>
      </div>
      <LoginRestriction open={isRestrictionOpen} />
    </Box>
  );
};

export default Favorites;
